import React from "react";

const Checkmark = () => (
  <svg width="111" height="75" viewBox="0 0 111 75" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M5 33L41.5 69.5L106 5" stroke="#54C36C" strokeWidth="10" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export default React.memo(Checkmark);
